import Swup from 'swup';

import Subscription from './subscription.js';
import ListingEditor from './listing-editor';
import JobEditor from './job-editor';

import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

import AOS from 'aos';
import './advocacy.js';

// Stripe Key
const stripeKey = document.getElementById('stripekey').dataset.key;

// Variables
const $d = $(document),
      $w = $(window),
      $b = $('body');

const swup = new Swup({});

const subscription = new Subscription(
  stripeKey
);
const jobEditor = new JobEditor(
  stripeKey
);
const listingEditor = new ListingEditor();

// Events
swup.hooks.on('content:replace', (visit) => {
  if (visit?.to?.document?.body) {
    document.body.className = visit.to.document.body.className;
  }
  init();
});

let inputs = 'input[type=text], input[type=password], input[type=email], textarea';
let textCycle;

$d.on('click', '.cookie_btn', setCookie)
  .on('click', '.readmore', showMore)
  .on('click', '.nav_mobile-trigger', toggleMobileMenu)
  .on('click', '.accordion_a', toggleAccordion)
  .on('click', '.intro_dropdown-trigger', toggleDropdown)
  .on('click', '.hero_play', showVideoOverlay)
  .on('click', '.hero_pause', showVideoOverlay)
  .on('click', '.intro_atoz', sortMembers)
  .on('click', 'a[href *= "#"]', handleHash)

  .on('keypress', toggleAdminHelpers)
  .on('focus', inputs, showFormLabel)
  .on('input', '.calculator_input input', updateLevy)
  .on('blur', inputs, hideFormLabel)
  .on('click', '#update-listing', disableSaveButton)
  .on('click', '#submit-update', disableSaveButton);


$w.on('scroll', function(e){
    let height = window.location.pathname == '/' ? $w.innerHeight()/2 : 0;

    if($w.scrollTop() > height) {
      $b.addClass('scrolled');
    } else {
      $b.removeClass('scrolled');
    }

});



document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  checkCookie();
  init();
  AOS.init({
    duration: 450,
    // easing: 'ease-in-out-cubic',
    // anchorPlacement: 'top-bottom',
    once: false,
    // mirror: false
    // offset: 350
  });
});





function handleHash(event) {
  l('handleHash');
  scrollToHash(getSamePageAnchor(this), event);

}

function getSamePageAnchor (link) {
  l('getSamePageAnchor');
  if (
    link.protocol !== window.location.protocol ||
    link.host !== window.location.host ||
    link.pathname !== window.location.pathname ||
    link.search !== window.location.search
  ) {
    return false;
  }
  return link.hash;
}

function scrollToHash(hash, e) {
  l('scrollToHash');
  let navHeight = $('.header').outerHeight();
  let offset, elem;
  if($('.intro-dashboard').length) {
    offset = $('.intro-dashboard').length ? navHeight + $('.intro-dashboard').outerHeight() : navHeight;
    elem = hash ? $(hash).offset().top - offset : false;
  } else {
    offset = $('.subnav').length ? navHeight + $('.subnav').outerHeight() : navHeight;
    elem = hash ? $(hash).offset().top - offset : false;
  }


  // l(elem);
  if(elem) {
    if(e) e.preventDefault();
    gsap.to(window, {
      ease: "power4.inOut",
      scrollTo: elem
    });
  }
}



// Functions
function l(m) {
  console.log(m);
}

function sortMembers(e) {

    e.preventDefault();
    if($('.tiles_members').hasClass('alpha')) {
      $('.tiles_directory').sort(function (a, b) {
        // if (a.textContent < b.textContent) {
        if ($(a).find('h4').text().trim() < $(b).find('h4').text().trim()) {
          return -1;
        } else {
          return 1;
        }
      }).appendTo('.tiles_members');
      $('.tiles_members').removeClass('alpha');
      $(this).empty().append('A–Z');
    } else {
      $('.tiles_directory').sort(function (a, b) {
        // if (a.textContent < b.textContent) {
        if ($(a).find('h4').text().trim() > $(b).find('h4').text().trim()) {
          return -1;
        } else {
          return 1;
        }
      }).appendTo('.tiles_members');
      $('.tiles_members').addClass('alpha');
      $(this).empty().append('Z–A');
    }


}

function showVideoOverlay() {
  let $hero = $(this).closest('.hero');
  let $video = $hero.find('.hero_video video').get(0);
  if($hero.hasClass('playing')) {
    $hero.removeClass('playing');
    $b.removeClass('hidenav');
    // stop video
    $video.pause();
    l('video paused')
  } else {
    $hero.addClass('playing');
    $b.addClass('hidenav');
    // play video
    $video.play();
    l('video playing');
  }
  $video.addEventListener('timeupdate', function(){
    updateProgressBar($hero);
  });

}

function updateProgressBar($hero) {
  var $bar = $hero.find('.hero_progress');
  let $video = $hero.find('.hero_video video').get(0);
  var percentage = Math.floor((100 / $video.duration) * $video.currentTime);
  $bar.val(percentage);
}

function updateLevy() {
  l('updateLevy');

  let val = $(this).val();
  let rate = $(this).data('percent');
  let amount = Math.round((rate / 100) * val)

  if(amount > 20000) {
    $('.calculator_amount').empty().append('20000');
  } else {
    $('.calculator_amount').empty().append(amount);
  }

}

function toggleMobileMenu() {
  l('toggleMobileMenu');
  if($b.hasClass('mobilemenu')) {
    $b.removeClass('mobilemenu')
  } else {
    $b.addClass('mobilemenu');
  }
}


function showFormLabel() {
  l('showFormLabel');
  $(this).parent().addClass('active');
}

function hideFormLabel() {
  l('hideFormLabel');
  $(this).parent().removeClass('active');
}

function addLoadingAnimation() {
  $(this).addClass('loading').empty().append('Loading...');
}

function removeLoadingAnimation() {
  $('#signup-button').removeClass('loading').empty().append('Pay Now');
}

function toggleAdminHelpers(e) {
  l('toggleAdminHelpers');
  if(e.key === 'a') {
    if($b.hasClass('noadmin')) {
      $b.removeClass('noadmin')
    } else {
      $b.addClass('noadmin');
    }
  }
}

function toggleDropdown(event) {
  event.preventDefault();

  l('toggleDropdown');
  let $dd = $(this).parent();
  if($dd.hasClass('show')) {
    $dd.removeClass('show');
  } else {
    $dd.addClass('show');
  }
}

function toggleAccordion(event) {
  event.preventDefault();
  let $parent = $(this).parent();
  let $content = $(this).next();
  let contentH = $content.find('.accordion_inner').height() + 50;
  // l(height);
  if($parent.hasClass('active')) {
    $parent.removeClass('active');
    $content.css({
      'height': 0
    });
  } else {
    $parent.addClass('active');
    $content.css({
      'height': contentH
    });
  }
}

function showMore() {
  l('showMore');
  if($(this).next().hasClass('show')) {
    // l(close);
    $(this).removeClass('alt').empty().append('Read More').next().css({
      'height': '0'
    }).removeClass('show');

  } else {

    let height = $(this).closest('div').find('.readmore_content').outerHeight();
    $(this).addClass('alt').empty().append('Close').next().css({
      'height': height
    }).addClass('show');
  }
}


function init() {
  l('👍');
  highlightActive();
  lazyImages();
  loadSubscriptions();
  loadDirectoryListingEditor();
  loadJobEditor();
  loadSwipers();
  scrollToTop();
  getHeaderHeight();
  showHeroImage();
  heroTextCycle();
  highlightSearchInput();
  scrollToHash(window.location.hash);
  highlightSaveButton();
}


function highlightSearchInput() {
  if(window.location.pathname == '/search') {
    $('.intro_search input[type=search]').focus();
  }
}

function heroTextCycle() {

  clearInterval(textCycle);

  textCycle = setInterval(() => {
    l('heroTextCycle');
    if($('.hero_cycle-slide.active').next().length == 0) {
      $('.hero_cycle-slide.active').removeClass('active');
      $('.hero_cycle-slide:first-child').addClass('active');
    } else {
      $('.hero_cycle-slide.active').removeClass('active').next().addClass('active');

    }
  }, 5000);
}

function showHeroImage(){
  setTimeout(()=> {
    $('.hero').addClass('show');
  }, 700);
  // animate in title and caption too
}

function scrollToTop() {
  gsap.to(window, {
    scrollTo: 0,
    duration: 0
  });
}

function highlightSaveButton() {
  $('.form-dashboard .form_btn label').on('click', function(){
    $('#update-listing').removeClass('disable');
    $('#submit-update').removeClass('disable');
  });

  $('.form-dashboard .form_field input').on('change', function() {
    $('#update-listing').removeClass('disable');
    $('#submit-update').removeClass('disable');
  });

  $('.form-dashboard .form_field textarea').on('change', function() {
    $('#update-listing').removeClass('disable');
    $('#submit-update').removeClass('disable');
  });

  $('.form-dashboard .form_fields input[type="checkbox"]').on('change', function() {
    $('#update-listing').removeClass('disable');
    $('#submit-update').removeClass('disable');
  });
}

function disableSaveButton() {
  $(this).addClass('disable');
}


function highlightActive() {
  $('.nav a.active').removeClass('active');
  let firstUrlSegment = window.location.pathname.split('/')[1];
  $('nav.nav a[href*="'+window.location.pathname+'"]').addClass('active');
  // l(firstUrlSegment);
  $('nav.nav a').each(function() {
    // l($(this).attr('href'));
    if($(this).attr('href').indexOf(firstUrlSegment) > -1) {
      $(this).addClass('active');
    }
    // if($(this).attr('href').split('/')[1] == firstUrlSegment) {
    //   $(this).addClass('active');
    // }
  });

  if(window.location.pathname == '/') {
    clearNav();
  }
}

function clearNav() {
  $('.nav a.active').removeClass('active');
}

function setCookie() {
  l('set cookie');
  document.cookie = 'cookie-note=1;max-age=864000';
  $('.cookie').addClass('hidden');
}

function checkCookie() {
  l('check cookie');
  if (document.cookie.indexOf('cookie-note=1') !== -1) {
      $('.cookie').addClass('hidden');
  } else {
      $('.cookie').removeClass('hidden');
  }

  if (document.cookie.indexOf('cookie-form=1') !== -1) {
      $('.overlay').addClass('hidden');
  } else {
      $('.overlay').removeClass('hidden');
  }

}

function loadSwipers() {

  l('loadSwipers');

  var swiperNews = new Swiper(".swiper-news", {
    slidesPerView: 1,
    spaceBetween: 0,
    // autoplay: {
    //   delay: 5000,
    // },
    loop: true,
    breakpoints: {
      // when window width is >= 320px
      600: {
        slidesPerView: 3
      },
      1400: {
        slidesPerView: 4
      },
    },
    navigation: {
      nextEl: ".swiper-news-next",
      prevEl: ".swiper-news-prev",
    },
  });

  var swiperProfile = new Swiper(".swiper-profile", {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    autoHeight: true,
    autoplay: {
      delay: 5000,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    loop: true,
    // breakpoints: {
    //   // when window width is >= 320px
    //   600: {
    //     slidesPerView: 3
    //   },
    //   1400: {
    //     slidesPerView: 1
    //   },
    // },
    navigation: {
      nextEl: ".swiper-profile-next",
      prevEl: ".swiper-profile-prev",
    },
  });

  var swiperDirectory = new Swiper(".swiper-directory", {
    // effect: "fade",
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
  });

  var swiperJobs = new Swiper(".swiper-jobs", {

    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    loop: true,
    spaceBetween: 0,
    // freeMode: true,
    allowTouchMove: true,
    navigation: {
      nextEl: ".swiper-jobs-next",
      prevEl: ".swiper-jobs-prev",
    },

  });

  var swiperTestimonials = new Swiper(".swiper-testimonials", {

    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    loop: true,
    autoHeight: true,
    spaceBetween: 0,
    breakpoints: {
      900: {
        slidesPerView: 1.5
      },
    },
    navigation: {
      nextEl: ".swiper-custom-next",
      prevEl: ".swiper-custom-prev",
    },
    allowTouchMove: true,
    freeMode: true,
  });

  var swiperCustom = new Swiper(".swiper-custom", {

    slidesPerView: 3.2,
    autoplay: {
      delay: 4000,
    },
    spaceBetween: 0,
    breakpoints: {
      1400: {
        slidesPerView: 4.2
      },
    },
    navigation: {
      nextEl: ".swiper-custom-next",
      prevEl: ".swiper-custom-prev",
    },

  });

  var swiperMg = new Swiper(".swiper-mg", {
    slidesPerView: 2,
    // autoplay: {
    //   delay: 3000,
    // },
    loop: true,
    freeMode: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      // when window width is >= 320px
      0: {
        slidesPerView: 2
      },
      1000: {
        slidesPerView: 3
      },
      1400: {
        slidesPerView: 4
      },
      1800: {
        slidesPerView: 5
      },
    }
  });

}

function lazyImages() {

    l('lazyImages');
    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
    if ("IntersectionObserver" in window) {
      let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
            // lazyImage.srcset = lazyImage.dataset.srcset;
            lazyImage.classList.add("animate");
            lazyImageObserver.unobserve(lazyImage);
            // throttle(loadIsotope, 200);
          }
        });
      });

      lazyImages.forEach(function (lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    }
}

// Subscriptions
function loadSubscriptions() {
  // Signup
  const subscriptionForm = document.querySelector('form#start-subscription')
  const subscriptionStripe = document.querySelector('form#start-subscription #stripe')
  const subscriptionButton = document.querySelector('form#start-subscription button#signup-button')
  if (subscriptionForm) {
    subscription.attachCheckout(
      subscriptionForm,
      subscriptionStripe,
      subscriptionButton,
      document.getElementById('stripeemerging').dataset.key,
      document.getElementById('stripeindividual').dataset.key,
    )
  }

  // Resignup
  const resignupErrors = document.querySelector('#re-signup #errors')
  const resignupStripe = document.querySelector('#re-signup-stripe')
  const resignupMembershipField = document.querySelector('#re-signup-options')
  const resignupButton = document.querySelector('#re-signup-submit')
  if (resignupErrors && resignupStripe) {
    subscription.attachResignup(
        resignupStripe,
        resignupMembershipField,
        resignupButton,
        resignupErrors,
        document.getElementById('stripeemerging').dataset.key,
        document.getElementById('re-signup-emerging-options'),
        document.getElementById('stripeindividual').dataset.key,
    )
  }

  // Update field
  const updateForm = document.querySelector('form#update-profile')
  const updateButton = document.querySelector('button#submit-update')
  if (updateForm && updateButton) {
    subscription.attachUpdate(updateForm, updateButton)
  }
}

// Directory Listing Editor
function loadDirectoryListingEditor() {
  const genres = document.querySelectorAll('input.genre');
  const productions = document.querySelector('#productions');
  const addProductions = document.querySelector('#add-productions');
  const awards = document.querySelector('#awards');
  const addAwards = document.querySelector('#add-awards');
  const updateButton = document.querySelector('#update-listing');
  const hideProfile = document.querySelector('#hide-profile');
  const hideAddress = document.querySelector('#hide-address');
  const images = document.querySelector('#listing-images');
  if (genres && productions && addProductions && awards && addAwards && images) {
    listingEditor.attachEditor(
        genres,
        productions,
        addProductions,
        awards,
        addAwards,
        updateButton,
        hideProfile,
        hideAddress,
        images
    );
  }
}

// Job Editor
function loadJobEditor() {
  const form = document.querySelector('#job-form')
  const submit = document.querySelector('#job-form>#submit-job')
  const stripe = document.querySelector('#job-form>#stripe')
  if(form && submit) {
    jobEditor.attachJobEditor(form, stripe, submit);
  }
}



function getHeaderHeight() {
  // const header = document.querySelector('.header');
  // const headerHeight = header.offsetHeight / 2;
  // const firstChildMain = document.querySelector('#swup').firstElementChild;
  // firstChildMain.style.paddingTop = headerHeight+'px';
}
